module.exports = {"653122100":"疏勒镇","653122101":"罕南力克镇","653122102":"牙甫泉镇","653122200":"巴仁乡","653122201":"洋大曼乡","653122202":"亚曼牙乡","653122203":"巴合齐乡","653122204":"塔孜洪乡","653122205":"英尔力克乡","653122206":"库木西力克乡","653122207":"塔尕尔其乡","653122208":"艾尔木东乡","653122209":"阿拉力乡","653122210":"阿拉甫乡","653122211":"英阿瓦提乡","653122400":"高新技术产业孵化园区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/653122.json
// module id = 3249
// module chunks = 0